<div class="card card-custom gutter-b example example-compact top-align">
  <div class="card-header">
      <h3 class="card-title">Trainer Feedback Form</h3>
      <div class="card-toolbar">
          <div class="example-tools justify-content-center">
              <span class="example-toggle" data-toggle="tooltip" title="" data-original-title="View code"></span>
              <span class="example-copy" data-toggle="tooltip" title="" data-original-title="Copy code"></span>
          </div>
      </div>
  </div>
  <div class="card-body" >
      <form class="form" [formGroup]="trainerFeedBackForm">
          <div formArrayName="feedbacks"
          *ngFor="let question of trainerFeedBackForm.get('feedbacks')['controls']; let i = index" class="form-group">
          <ng-container [formGroupName]="i">

            <div  formGroupName="feedback">
                <label class="label-text" >{{questions[i].id}}) {{displayQuestion(questions[i].id,questions[i].questionString)}}</label>
                <ng-container *ngIf="questions[i].id !== 'Q5'">
                  <ng-container *ngIf="questions[i].id !== 'Q6'">
                    <div class="radio-list" >
                      <label style="margin-left: 20px;" class="radio">
                          <input type="radio" (change)="validate(i)"  formControlName="choice"  [value]="true" >
                          <span></span>
                          Yes
                      </label>
                      <label style="margin-left: 20px;"  class="radio">
                        <input type="radio" (change)="validate(i)" formControlName="choice"  [value]="false" >
                        <span></span>
                        No
                    </label>
                  </div>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="questions[i].id === 'Q5'">
                  <div class="form-group">
                    <input style="width: 32%;" formControlName="choice"  type="text" maxlength="50"  class="form-control" placeholder="Write your asnwer ( max character: 50 )">
                  </div>
                </ng-container>
                <ng-container *ngIf="questions[i].id === 'Q6'">
                  <div class="form-group">
                    <input style="width: 32%;" formControlName="choice"  type="text" maxlength="50"  class="form-control" placeholder="Write your asnwer ( max character: 50 )">
                  </div>
                </ng-container>
               
              </div>
          </ng-container>
          </div>
          <div class="card-footer">
            <ng-container *ngIf="role !== 'Continuous Monitoring'">
              <ng-container *ngIf="!isUpdate">
                <button [disabled]="trainerFeedBackForm.status === 'INVALID'" class="btn btn-primary mr-2"  (click)="sumitFeedback()">Submit</button>
                <!-- <button  class="btn btn-primary mr-2"  (click)="reset()">Reset</button> -->

              </ng-container>
            </ng-container>
            <button  class="btn btn-secondary" (click)="goBack()">Back</button>
          </div>
      </form>
</div>
</div>

   